import { Box } from 'components/Box';
import { TrackedConditionalLink } from 'components/Link';
import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiImageBlockData } from 'modules/cms/api/types/blocks/CmsApiImageBlock';
import { colors } from 'theme';

import { CmsImageBlockImageOrFigureContainer } from './CmsImageBlock.styled';
import { CmsImageBlockImage } from './CmsImageBlockImage';

type Props = {
  data: CmsApiImageBlockData;
  className?: string;
  fullWidthLayout?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsImageBlock({
  data: { headline, subtitle, image, url, keepDimensions },
  className,
  fullWidthLayout,
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Box
      as="figure"
      m={0}
      w={1}
      fullWidthLayout={fullWidthLayout}
      className={className}
      data-qa-id="cms-image-block"
      data-qa-keep-dimensions={Boolean(keepDimensions)}
    >
      {(headline || subtitle) && (
        <Box as="figcaption" mb={48}>
          {headline && (
            <RichTextHeadline textAlignCenter={fullWidthLayout}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Image',
                },
              }}
              textAlign={fullWidthLayout ? 'center' : 'left'}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}

      <CmsImageBlockImageOrFigureContainer
        as={headline || subtitle ? 'figure' : 'div'}
      >
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated,
          }}
          aria-label={image.altText || getText('Follow image link')}
        >
          <CmsImageBlockImage
            image={image}
            keepDimensions={keepDimensions}
            fullWidthLayout={Boolean(fullWidthLayout)}
          />
        </TrackedConditionalLink>

        {image.caption && (
          <BodySmall color={colors.lightContentGrey} mt="8px" as="figcaption">
            {image.caption}
          </BodySmall>
        )}
      </CmsImageBlockImageOrFigureContainer>
    </Box>
  );
}
